import React, { createContext, useContext, useState, useCallback } from 'react';

const RecoveryContext = createContext(null);

export const useRecovery = () => {
    const context = useContext(RecoveryContext);
    if (!context) {
        throw new Error('useRecovery must be used within a RecoveryProvider');
    }
    return context;
};

export const RecoveryProvider = ({ children }) => {
    const [isPanelOpen, setIsPanelOpen] = useState(false);
    const [isMinimized, setIsMinimized] = useState(false);
    const [isScanning, setIsScanning] = useState(false);

    // Trigger to start scanning (consumed by MessageRecoveryPanel)
    const [scanTrigger, setScanTrigger] = useState(0);

    const openPanel = useCallback(() => {
        setIsPanelOpen(true);
        setIsMinimized(false);
    }, []);

    const closePanel = useCallback(() => {
        setIsPanelOpen(false);
    }, []);

    const minimizePanel = useCallback(() => {
        setIsMinimized(true);
    }, []);

    const maximizePanel = useCallback(() => {
        setIsMinimized(false);
        setIsPanelOpen(true);
    }, []);

    const startScan = useCallback(() => {
        setIsPanelOpen(true);
        setIsMinimized(false);
        setScanTrigger(prev => prev + 1);
    }, []);

    return (
        <RecoveryContext.Provider value={{
            isPanelOpen,
            setIsPanelOpen,
            isMinimized,
            setIsMinimized,
            isScanning,
            setIsScanning,
            scanTrigger,
            openPanel,
            closePanel,
            minimizePanel,
            maximizePanel,
            startScan
        }}>
            {children}
        </RecoveryContext.Provider>
    );
};
